<script>
  import Pagination from '@/components/pagination/index.vue';
  import BaseListLayout from '@/views/layout/components/BaseListLayout.vue';
  import { myMixin } from '@/mixins/mixins.js';
  import {
    downloadAdvertiserBilling,
    getAdvertiserBillingList,
  } from 'api/billing/advertiserBilling';
  import { handleSortItem } from 'utils/utils';
  import CheckboxWatcher from '@/mixins/checkboxWatcher';
  import { formatDate } from 'utils/dateutils';
  import GroupSelect from '@/components/GroupSelect/index.vue';
  import { billingEnumMixins } from '@/mixins/billingEnumMixins';
  import { financeInfoMixins } from '@/mixins/financeInfoMixins';
  import { roleUserMixins } from '@/mixins/roleUserMixins';

  export default {
    name: 'AdvertiserBilling',
    components: { GroupSelect, BaseListLayout, Pagination },
    mixins: [myMixin, financeInfoMixins, CheckboxWatcher, billingEnumMixins, roleUserMixins],
    data() {
      return {
        groupItemCheck: {
          advIdCheck: false,
          advNameCheck: false,
          companyEntityCheck: false,
          hyperTapEntityCheck: false,
          companyPlatformCheck: false,
          pmNameCheck: false,
          bdNameCheck: false,
          billingEntityCheck: false,
          reconciliationProgressCheck: false,
          receiptStatusCheck: false,
          advInvoiceAppStatusCheck: false,
        },
        dialogVisible: false,
        dialogType: 'new',
        total: 0,
        listLoading: false,
        dataList: [],
        filter: {
          page: 1,
          pageSize: 10,
          businessModule: null,
          advCompanyPlatform: null,
          hyperTapEntity: null,
          advInvoiceAppStatus: null,
          advId: null,
          advName: null,
          pmId: null,
          bdId: null,
          receiptStatus: null,
          reconciliationProgress: null,
          recordDateRange: [formatDate(new Date(), 'yyyy-MM'), formatDate(new Date(), 'yyyy-MM')],
          receiptTimeRange: null,
          sortItems: [],
          groupItems: [],
        },
      };
    },
    created() {
      this.filter.groupItems.push('fbd.record_date');
    },
    mounted() {
      this.handleSearch();
      this.checkboxConfig.targetArray = this.filter.groupItems;
      this.checkboxConfig.searchFunc = this.handleSearch;
    },
    methods: {
      handleSizeChange(size) {
        this.filter.pageSize = size;
        this.handleSearch(1);
      },
      handleCurrentChange(currentPage) {
        this.filter.page = currentPage;
        this.handleSearch(currentPage);
      },
      handleDownload() {
        downloadAdvertiserBilling(this.filter);
      },
      handleSelectAll() {
        Object.keys(this.groupItemCheck).forEach((key) => {
          this.$set(this.groupItemCheck, key, true);
        });
        this.handleSelectAllCb();
      },
      handleUnSelectAll() {
        Object.keys(this.groupItemCheck).forEach((key) => {
          this.$set(this.groupItemCheck, key, false);
        });
        this.handleUnSelectAllCb();
      },
      handleSort(columnInfo) {
        const sortItem = handleSortItem(columnInfo);
        if (sortItem === '') {
          this.filter.sortItems = [];
          this.handleSearch(1);
          return;
        }
        this.filter.sortItems = [];
        this.filter.sortItems.push(sortItem);
        this.handleSearch(1);
      },
      handleSearch(page) {
        this.listLoading = true;
        if (page) {
          this.filter.page = page;
        }
        getAdvertiserBillingList(this.filter)
          .then((res) => {
            if (res) {
              const result = res.result;
              this.dataList = result.dataList;
              this.total = res.total;
            }
          })
          .catch(() => {})
          .finally(() => {
            this.listLoading = false;
          });
      },
      getReceiptLabel(status) {
        if (status === null || status === undefined) {
          return '';
        }
        return this.advHedgeAppReceiptStatusList.find((item) => item.value === status)?.label || '';
      },
      getReconciliationProgressLabel(status) {
        if (status === null || status === undefined) {
          return '';
        }
        return this.reconciliationProgressList.find((item) => item.value === status)?.label || '';
      },
      sourceDetailClick(row) {
        const { href } = this.$router.resolve({
          path: '/source/detail',
          query: {
            sourceId: row.advId,
          },
        });
        window.open(href, '_blank');
      },
    },
  };
</script>

<template>
  <base-list-layout :title="'Advertiser Billing'">
    <template #search>
      <el-form :inline="true" :model="filter" label-width="180px" ref="searchForm">
        <el-form-item label="Date">
          <div class="row-multi-item">
            <el-date-picker
              v-model="filter.recordDateRange"
              format="yyyy-MM"
              value-format="yyyy-MM"
              type="monthrange"
              clearable
              style="width:260px;"
              align="right"
              unlink-panels
              range-separator="to"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="monthPickerOptions"
            />
          </div>
        </el-form-item>
        <el-form-item label="Receipt Time">
          <el-date-picker
            v-model="filter.receiptTimeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="datetimeRangePickerOptions"
          />
        </el-form-item>
        <el-form-item label="Advertiser ID">
          <div class="row-multi-item">
            <group-select
              v-model="filter.advId"
              :data-source="sourcesList"
              :loading="sourceLoading"
              clearable
              filterable
              reserve-keyword
            />
            <el-checkbox v-model="groupItemCheck.advIdCheck" name="advertiser_id" />
          </div>
        </el-form-item>
        <el-form-item label="Advertiser Name">
          <div class="row-multi-item">
            <group-select
              v-model="filter.advName"
              :data-source="sourcesNameList"
              :loading="sourceLoading"
              clearable
              filterable
              reserve-keyword
            />
            <el-checkbox
              ref="advNameCb"
              v-model="groupItemCheck.advNameCheck"
              name="advertiser_name"
            />
          </div>
        </el-form-item>
        <el-form-item label="Company Platform">
          <div class="row-multi-item">
            <el-select
              v-model="filter.advCompanyPlatform"
              filterable
              clearable
              @change="handleCompanyPlatformChange(filter.advCompanyPlatform)"
            >
              <el-option
                v-for="item in companyPlatformList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
            <el-checkbox
              v-model="groupItemCheck.companyPlatformCheck"
              name="adv_company_platform"
            />
          </div>
        </el-form-item>
        <el-form-item label="Adv Entity">
          <div class="row-multi-item">
            <el-select v-model="filter.advEntity" ref="companyEntityOptions" filterable clearable>
              <el-option
                v-for="item in specificCompanyEntity"
                :key="item.id"
                :label="item.companyEntity"
                :value="item.companyEntity"
              />
            </el-select>
            <el-checkbox v-model="groupItemCheck.companyEntityCheck" name="frca.adv_entity" />
          </div>
        </el-form-item>
        <el-form-item label="HyperTap Entity">
          <div class="row-multi-item">
            <el-select v-model="filter.hyperTapEntity" filterable clearable>
              <el-option
                v-for="item in hyperTapCompanyEntities"
                :key="item.bfiId"
                :label="item.companyEntityAlias"
                :value="item.companyEntity"
              />
            </el-select>
            <el-checkbox
              v-model="groupItemCheck.hyperTapEntityCheck"
              name="frca.hyper_tap_entity"
            />
          </div>
        </el-form-item>
        <el-form-item label="Reconciliation Progress">
          <div class="row-multi-item">
            <el-select v-model="filter.reconciliationProgress" filterable clearable>
              <el-option
                v-for="item in reconciliationProgressList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-checkbox
              v-model="groupItemCheck.reconciliationProgressCheck"
              name="adv_reconciliation_progress"
            />
          </div>
        </el-form-item>
        <el-form-item label="PM Name">
          <div class="row-multi-item">
            <el-select v-model="filter.pmId" filterable clearable>
              <el-option
                v-for="item in allPmList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-checkbox v-model="groupItemCheck.pmNameCheck" name="advertiser_pm" />
          </div>
        </el-form-item>
        <el-form-item label="BD Name">
          <div class="row-multi-item">
            <el-select v-model="filter.bdId" filterable clearable>
              <el-option
                v-for="item in allBdList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-checkbox v-model="groupItemCheck.bdNameCheck" name="advertiser_bd" />
          </div>
        </el-form-item>
        <el-form-item label="Receipt Status">
          <div class="row-multi-item">
            <el-select v-model="filter.receiptStatus" filterable clearable>
              <el-option
                v-for="item in advFullReceiptStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-checkbox v-model="groupItemCheck.receiptStatusCheck" name="frca.receipt_status" />
          </div>
        </el-form-item>
        <el-form-item label="Invoice Application Status">
          <div class="row-multi-item">
            <el-select v-model="filter.advInvoiceAppStatus" filterable clearable>
              <el-option
                v-for="item in advInvoiceAppAuditStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-checkbox
              v-model="groupItemCheck.advInvoiceAppStatusCheck"
              name="adv_invoice_app_status"
            />
          </div>
        </el-form-item>
      </el-form>
    </template>
    <template #search-actions>
      <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch(1)"
        >Search</el-button
      >
      <el-button type="primary" size="small" icon="el-icon-download" @click="handleDownload">
        Download Excel
      </el-button>
      <el-button type="primary" size="small" @click="handleSelectAll">SelectAll</el-button>
      <el-button type="primary" size="small" @click="handleUnSelectAll">UnSelectAll</el-button>
    </template>
    <template #table>
      <el-table
        v-loading="listLoading"
        ref="tableRef"
        :data="dataList"
        highlight-current-row
        @sort-change="handleSort"
      >
        <el-table-column
          label="Date"
          prop="recordDate"
          fixed="left"
          align="center"
          width="120"
          sortable="custom"
          key="recordDate"
        />
        <el-table-column
          label="Advertiser ID"
          prop="advId"
          align="center"
          width="170"
          key="advId"
          v-if="groupItemCheck.advIdCheck"
        >
          <template slot-scope="scope">
            <span class="cor337ab7" @click="sourceDetailClick(scope.row)">{{
              scope.row.advId
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Advertiser Name"
          prop="advName"
          align="center"
          width="170"
          key="advName"
          v-if="groupItemCheck.advNameCheck"
        >
          <template slot-scope="scope">
            <span class="cor337ab7" @click="sourceDetailClick(scope.row)">{{
              scope.row.advName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Company Platform"
          prop="advCompanyPlatform"
          align="center"
          width="170"
          key="advCompanyPlatform"
          v-if="groupItemCheck.companyPlatformCheck"
        />
        <el-table-column
          label="Adv Entity"
          prop="advEntity"
          align="center"
          width="170"
          key="advEntity"
          v-if="groupItemCheck.companyEntityCheck"
        />
        <el-table-column
          label="HyperTap Entity"
          prop="hyperTapEntity"
          align="center"
          width="170"
          key="hyperTapEntity"
          v-if="groupItemCheck.hyperTapEntityCheck"
        />
        <el-table-column
          label="BD Name"
          prop="bdName"
          align="center"
          key="bdName"
          width="100"
          v-if="groupItemCheck.bdNameCheck"
        />
        <el-table-column
          label="PM Name"
          prop="pmName"
          align="center"
          key="pmName"
          width="100"
          v-if="groupItemCheck.pmNameCheck"
        />
        <el-table-column
          label="Adv Revenue"
          prop="advRevenue"
          align="center"
          key="advRevenue"
          sortable="custom"
          width="140"
        />
        <el-table-column
          label="Adv Conversion"
          prop="advConversion"
          align="center"
          key="advConversion"
          sortable="custom"
          width="170"
        />
        <el-table-column
          label="Adv Deduction Amount"
          prop="advDeductionAmount"
          align="center"
          key="advDeductionAmount"
          sortable="custom"
          width="210"
        />
        <el-table-column
          label="Adv Cover Amount"
          prop="advCoverAmount"
          align="center"
          key="advCoverAmount"
          sortable="custom"
          width="210"
        />
        <el-table-column
          label="Adv Confirmed Amount"
          prop="advConfirmedAmount"
          align="center"
          key="advConfirmedAmount"
          sortable="custom"
          width="210"
        />
        <el-table-column
          label="Settlement Rate"
          prop="settlementRate"
          align="center"
          key="settlementRate"
          width="160"
        >
          <template slot-scope="scope"> {{ scope.row.settlementRate * 100 }}% </template>
        </el-table-column>
        <el-table-column
          label="Actual Amount"
          prop="advActualAmount"
          align="center"
          key="advActualAmount"
          sortable="custom"
          width="160"
        />
        <el-table-column
          label="Adv Hedge Amount"
          prop="advHedgeAmount"
          align="center"
          key="advHedgeAmount"
          sortable="custom"
          width="180"
        />
        <el-table-column
          label="Finance Received Amount"
          prop="financeReceivedAmount"
          align="center"
          key="financeReceivedAmount"
          sortable="custom"
          width="220"
        />
        <el-table-column
          label="Receipt Time"
          prop="receiptTime"
          align="center"
          key="receiptTime"
          width="160"
        />
        <el-table-column
          label="Invoice Application Status"
          prop="advInvoiceAppStatus"
          align="center"
          width="220"
          key="advInvoiceAppStatus"
          v-if="groupItemCheck.advInvoiceAppStatusCheck"
        />
        <el-table-column
          label="Reconciliation Progress"
          prop="reconciliationProgress"
          align="center"
          key="reconciliationProgress"
          width="190"
          fixed="right"
          v-if="groupItemCheck.reconciliationProgressCheck"
        >
          <template #default="scope">
            {{ getReconciliationProgressLabel(scope.row.reconciliationProgress) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Receipt Status"
          prop="receiptStatus"
          align="center"
          key="receiptStatus"
          width="190"
          v-if="groupItemCheck.receiptStatusCheck"
        >
          <template #default="scope">
            {{ getReceiptLabel(scope.row.receiptStatus) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Create Time"
          prop="createTime"
          align="center"
          key="createTime"
          width="160"
        />
        <el-table-column
          label="Create By"
          prop="createBy"
          align="center"
          key="createBy"
          width="160"
        />
      </el-table>
    </template>
    <template #pagination>
      <pagination
        class="block pagePanel"
        :pageTotal="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        :pageSize="filter.pageSize"
        :currentPage="filter.page"
      />
    </template>
  </base-list-layout>
</template>

<style scoped lang="scss"></style>
